import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalLetter',
    standalone: false
})
export class CapitalLettertPipe implements PipeTransform {
  transform(value: string | null | undefined): string | null {
    if (!value) {
      return value;
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
